// QR rendering for the bunker login flow.
//
// We display the nostrconnect:// URI as a QR code; the remote signer scans
// it (we never scan a signer-presented QR). Light theme inside the QR card
// even in dark mode so phone cameras can always read the contrast.

import QRCode from 'qrcode';

export interface RenderBunkerQrOpts {
  margin?: number;
  width?: number;
  darkColor?: string;
  lightColor?: string;
}

export async function renderBunkerQr(
  uri: string,
  canvas: HTMLCanvasElement,
  opts: RenderBunkerQrOpts = {},
): Promise<void> {
  await QRCode.toCanvas(canvas, uri, {
    margin: opts.margin ?? 1,
    width: opts.width ?? 200,
    errorCorrectionLevel: 'M',
    color: {
      dark: opts.darkColor ?? '#000000',
      light: opts.lightColor ?? '#FFFFFF',
    },
  });
}
